"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _propTypes = _interopRequireDefault(require("prop-types"));
var _constant = require("../../Theme/constant");
var _constant2 = require("./constant");
var _default = exports.default = {
  PropTypes: {
    label: _propTypes.default.string.isRequired,
    iconColor: _propTypes.default.oneOf(_constant.ARR_COLORS),
    theme: _propTypes.default.string,
    backgroundColor: _propTypes.default.oneOf(_constant.ARR_BACKGROUND_COLORS),
    labelColor: _propTypes.default.oneOf(_constant.ARR_COLORS),
    bold: _propTypes.default.bool,
    onIconClick: _propTypes.default.func,
    customProperties: _propTypes.default.object,
    idConfig: _propTypes.default.exact({
      widgetName: _propTypes.default.string,
      parentName: _propTypes.default.string,
      index: _propTypes.default.string
    })
  },
  DefaultProps: {
    iconColor: _constant2.ICON.COLOR,
    backgroundColor: _constant2.DEFAULT_BACKGROUND_COLOR,
    labelColor: _constant2.LABEL_COLOR,
    bold: true,
    theme: _constant.DEFAULT_THEME,
    onIconClick: () => {}
  }
};